/**
 *  Initialize Helper
 */

var helper = (function () {
	var browserCacheExpiry = 120;

	var pub = {}; // public facing functions

	pub.init = function () {
	};

	pub.SetLocalData = function (key, data) {
		localStorage.setItem(key, data);
		setBrowserCacheExpiryTime(function (newExpiryTime) {
			localStorage.setItem(key + "_expiry", $.now() + newExpiryTime);
		});
	};

	pub.LocalDataExpired = function (key) {
		var expiry = localStorage.getItem(key + "_expiry");
		if (expiry !== undefined && expiry !== null && expiry !== "") {
			if (parseInt(expiry) > $.now())
				return false;
			else
				return true;
		} else {
			return true;
		}
	};

	pub.HTTP_GET = function (url, callback) {
		//Vanilla javascript way of doing ajax when jquery is not available
		var xmlhttp = new XMLHttpRequest();
		xmlhttp.onreadystatechange = function () {
			if (xmlhttp.readyState === XMLHttpRequest.DONE) {   // XMLHttpRequest.DONE == 4
				if (xmlhttp.status === 200) {
					callback(xmlhttp.responseText);
				}
				else {
					console.log('There was an error in getting data from ' + url);
					callback(false);
				}
			}
		};
		xmlhttp.open("GET", url, true);
		xmlhttp.send();
	};

	function setBrowserCacheExpiryTime(callback) {
		callback(browserCacheExpiry * 60 * 1000);

	//	pub.HTTP_GET("/Pages/AppSettings", function (response) {
	//		var data = JSON.parse(response);
	//		callback(data.browserCacheExpiry * 60 * 1000);
	//	});
	}

	return pub;
})();
